var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDistanceCalculator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 120,
    viewBox: "0 0 94 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.864 119.77H45.22S18.596 86.29 10.043 74.03c-2.657-3.807-4.673-7.768-6.19-11.42C1.338 56.557.002 50.103 0 43.654c0-4.8.738-9.599 2.28-14.227C12.093 0 45.22 0 45.22 0c1.658 0 3.307.085 4.942.257-5.326.25-33.197 2.829-42.055 29.4C4.49 40.503 5.292 52.28 9.679 62.841c1.517 3.652 3.533 7.613 6.19 11.42 8.138 11.665 32.636 42.54 34.995 45.509m-.145-47.262c-14.672 0-26.673-10.895-28.093-25.133 1.578 13.9 13.382 24.728 27.77 24.9h.091l.021.001h.095l.021.001h.122c15.629 0 28.298-12.571 28.298-28.08a28.02 28.02 0 0 0-.426-4.88 27.99 27.99 0 0 1 .465 5.11c-.012 15.558-12.708 28.046-28.299 28.08h-.065",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.746 72.277H50.508l-.021-.001h-.09A28.32 28.32 0 0 1 27.03 59.511a24.264 24.264 0 0 0 19.127 9.282c13.39 0 24.245-10.77 24.245-24.057 0-13.287-10.855-24.058-24.245-24.058A24.254 24.254 0 0 0 24.07 34.816C27.963 23.923 38.433 16.12 50.746 16.12c15.629 0 28.298 12.571 28.298 28.078 0 15.509-12.67 28.08-28.298 28.08",
    id: "b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#00B9E6",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.3,
    fill: "#000",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.784 72.507c-15.698.034-28.357-12.405-28.298-28.08.058-15.507 12.67-28.078 28.298-28.078 15.629 0 28.31 12.571 28.299 28.079-.012 15.557-12.708 28.045-28.299 28.08m35.671-54.436C77.54 5.902 64.573.23 51.047.23c0 0-33.13 0-42.94 29.427C4.49 40.503 5.292 52.28 9.679 62.841c1.517 3.652 3.533 7.613 6.19 11.42C24.421 86.521 51.046 120 51.046 120s30.76-41.99 37.53-55.17c7.036-13.696 8.117-32.783-2.122-46.758",
    fill: "#00B9E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#00B9E6",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.3,
    fill: "#000",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51 53v8h-8v-8h8zm0-24v19h-8V29h8z",
    fill: "#000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceCalculator);
export default __webpack_public_path__ + "static/media/distance-calculator.a598629a8477e7756dbd56f566265eb9.svg";
export { ForwardRef as ReactComponent };